import { Component, input, output, ViewChild } from '@angular/core';
import { PropertyListPage } from "../../../property/components/property-list/property-list.component";
import { BootstrapService } from '../../../../core/services/bootstrap.service';
import { ModalActions, ModalTypes } from '../../../../core/enums/base.enums';
import { PropertyMemberTypes } from '../../../../core/enums/data.enums';
import { PropertyListViewLocations } from '../../../../core/enums/base.enums';
import { PropertiesService } from '../../../../core/services/property.service';
import { InfoModalComponent } from "../../../../parts/info-modal/info-modal.component";
import { ConfirmationModalComponent } from "../../../../parts/confirmation-modal/confirmation-modal.component";
import { MembersMessagingConstants } from '../../../../core/constants/messaging.constants';
import { MemberModel } from '../../../../core/models/data/member.model';
import { PropertyModel } from '../../../../core/models/data/property.model';
import { EscCloseDirective } from '../../../../core/directives/esc-close.directive';

@Component({
  selector: 'ms-add-properties-to-member',
  imports: [PropertyListPage, InfoModalComponent, ConfirmationModalComponent, EscCloseDirective],
  templateUrl: './add-properties-to-member.component.html'
})
export class AddPropertiesToMemberComponent {
  public member = input<MemberModel>();
  public propertyListViewLocations = PropertyListViewLocations;
  
  public propertyIdToAddMemberTo: number = 0;
  public propertyMemberTypeToAdd : PropertyMemberTypes = PropertyMemberTypes.Owner;
  
  public isSubmitting = false;

  public memberAddedToProperty = output<void>();

  @ViewChild('addPropertiesToMemberInfoModalRef') addPropertiesToMemberInfoModalRef!: InfoModalComponent;
  @ViewChild('addPropertiesToMemberConfirmationModalRef') addPropertiesToMemberConfirmationModalRef!: ConfirmationModalComponent;

  constructor(
    private bootstrapService: BootstrapService,
    private propertyService: PropertiesService
  ) { }

  public onAddMemberRequested(event: {property: PropertyModel, memberType: PropertyMemberTypes}): void {
    this.propertyIdToAddMemberTo = event.property.propertyId;
    this.propertyMemberTypeToAdd = event.memberType;

    this.addPropertiesToMemberConfirmationModalRef.modalType.set(ModalTypes.Question);

    const confirmationData = {firstName: this.member()?.firstName, lastName: this.member()?.lastName};
    const confirmationMessage = MembersMessagingConstants.MEMBERS_ADD_TO_PROPERTY_CONFIRMATION().replaceValuesWithObject(confirmationData);

    this.addPropertiesToMemberConfirmationModalRef.message.set(confirmationMessage);

    this.bootstrapService.manageModal("#addPropertiesToMemberModal", ModalActions.Hide);
    this.bootstrapService.manageModal("#addPropertiesToMemberConfirmationModal", ModalActions.Show);
  }

  public async addMemberToProperty(): Promise<void> {
    if (this.member()) {
      this.isSubmitting = true;
      try {
        const result = await this.propertyService.addMemberToProperty(
          this.propertyIdToAddMemberTo, 
          {memberIds: [this.member()?.memberId!], 
          memberType: this.propertyMemberTypeToAdd}
        );
        
        if(result.success === false) {
          this.addPropertiesToMemberInfoModalRef.modalType.set(ModalTypes.Failure);
        } else {
          this.addPropertiesToMemberInfoModalRef.modalType.set(ModalTypes.Success);
        }

        this.addPropertiesToMemberInfoModalRef.message.set(result.message!);
        
        this.bootstrapService.manageModal("#addPropertiesToMemberConfirmationModal", ModalActions.Hide);
        this.bootstrapService.manageModal("#addPropertiesToMemberInfoModal", ModalActions.Show);
        
        if (result.success) {
          this.memberAddedToProperty.emit();
        }
      } finally {
        this.isSubmitting = false;
      }
    }
  }

  public abortConfirmation(): void {
    this.bootstrapService.manageModal("#addPropertiesToMemberConfirmationModal", ModalActions.Hide);
    this.bootstrapService.manageModal("#addPropertiesToMemberModal", ModalActions.Show);
  }
  
  public onCancelRequested(): void {
    this.bootstrapService.manageModal("#addPropertiesToMemberModal", ModalActions.Hide);
  }
  
  public openAddMemberToPropertiesModal(): void {
    this.bootstrapService.manageModal("#addPropertiesToMemberModal", ModalActions.Show);
  }

  public onConfirmInfoModal(): void {
    this.bootstrapService.manageModal("#addPropertiesToMemberModal", ModalActions.Show);
  }
}
